import React, { useState, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { listSchedules, unloadUserSchedules } from '../../modules/userModule/schedules';
import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';
import ScheduleCalendar from '../../components/schedulemng/ScheduleCalendar';
import ScheduleTemplate from '../../components/schedulemng/ScheduleTemplate';
import CalendarModalContainer from './CalendarModalContainer';
import TechEditStepperModalContainer from './TechEditStepperModalContainer';

const ScheduleContainer = () => {
    const dispatch = useDispatch();

    const { schedules, error, loading } = useSelector(
        ({ userModule, loading }) => ({
            schedules: userModule.schedules.schedules,
            error: userModule.schedules.error,
            loading: loading['user/LIST_USER_SCHEDULES'],
        }),
    );

    const [events, setEvents] = useState([]);
    const [type, setType] = useState(null);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setSelectedEvent(null);
    };


    useEffect(() => {
        dispatch(listSchedules());
    }, [])

    useEffect(() => {
        if (schedules) {
            setEvents([...schedules])
        }

    }, [schedules])



    const handelEventClick = (e) => {
        // console.log(e.event, "event");
        setSelectedEvent(e.event);
        setType(e.event.extendedProps.type)
        handleOpen();
    }


    return (
        <>
            <BreadcrumbsContainer title="공통관리/스케줄 관리/캘린더" icon="schedule" />
            <ScheduleTemplate loading={loading} error={error} schedules={schedules}>
                <ScheduleCalendar events={events} handelEventClick={handelEventClick} />
                {open && type === 'tech' && <TechEditStepperModalContainer open={open} handleClose={handleClose} reqId={selectedEvent.extendedProps.taskUuid} />}
            </ScheduleTemplate>
        </>
    )
}

export default ScheduleContainer